import { LoanPageType } from './LoanPageType';

export const LoanPageOptions = [
    {
        id: LoanPageType.Landing,
        name: '',
    },
    {
        id: LoanPageType.LOC,
        name: 'LOC',
    },
    {
        id: LoanPageType.Construction,
        name: 'Construction',
    },
    {
        id: LoanPageType.Rental,
        name: 'Rental',
    },
    {
        id: LoanPageType.BuildRent,
        name: 'Build Rent',
    },
    {
        id: LoanPageType.FixFlip,
        name: 'Fix-Flip',
    },
    {
        id: LoanPageType.Land,
        name: 'Land',
    },
    {
        id: LoanPageType.Model,
        name: 'Model',
    },
    {
        id: LoanPageType.Bridge,
        name: 'Bridge',
    },
];
